const GIFS = [{
    row : 1,
    label : 'Cold Calls',
    gifs : ['GIF_in/01-welldone','GIF_in/01-nomute','GIF_in/01-waiting','GIF_in/01-allright','GIF_in/01-bleh','GIF_in/01-food','GIF_in/01-hangup','GIF_in/01-inbound','GIF_in/01-letsgo','GIF_in/01-nomore']
},
{
    row : 2,
    label : 'Quota Chasing',
    gifs : ['GIF_in/02-chasing','GIF_in/02-justdoit','GIF_in/02-closer','GIF_in/02-cute','GIF_in/02-food','GIF_in/02-getitin','GIF_in/02-hardwork','GIF_in/02-life','GIF_in/02-monkey','GIF_in/02-spaced','GIF_in/02-wfh']
},
{
    row : 3,
    label : 'Quota Crushing',
    gifs : ['GIF_in/03-cheer','GIF_in/03-chillin','GIF_in/03-confetti','GIF_in/03-winning','GIF_in/03-yaasss','GIF_in/03-zach', 'jesse/eat-success','jesse/crush',]
},
{
    row : 4,
    label : 'Quota Desperation',
    gifs : ['GIF_in/04-cats','GIF_in/04-coffee','GIF_in/04-melting','GIF_in/04-rain','GIF_in/04-smell','GIF_in/04-stephcurry','GIF_in/04-times','GIF_in/04-typing','GIF_in/04-wine','GIF_in/04-wrong',]
},
{
    row : 5,
    label : 'Nailed Commission',
    gifs : ['GIF_in/05-andy','GIF_in/05-crusshed','GIF_in/05-nailed','GIF_in/05-nailedit','GIF_in/05-welldone','GIF_in/05-wonderwoman','jesse/chevy','jesse/abc', 'jesse/yeah']
},
{
    row : 6,
    label : 'Cancelled',
    gifs : ['GIF_in/06-disagree','GIF_in/06-finn','GIF_in/06-spider','jesse/lets-do-lunch','dont-find-bf','jesse/computer-beavis','omg','what','explode']
},
{
    row : 7,
    label : 'When you get Ghosted',
    gifs : ['GIF_in/07-ghosted','GIF_in/07-ghosting','GIF_in/07-fade','GIF_in/07-homer','GIF_in/07-literal','GIF_in/07-phone','GIF_in/07-sp00ky','jesse/cry','jesse/best-friend','jesse/whats-the-deal',]
},
{
    row : 8,
    label : 'Competitor Defenses',
    gifs : ['zoomsar','die-hard','knowledge','its-ok','gator','wow','say-what','help-me-you','shrug','slap','get-hero','deal-with-it','jesse/i-have-problems']
},
];
export default GIFS;